import * as React from 'react'; 
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorPage } from '@/components/ErrorPage/ErroPage';

export const RenderError:React.FC  = () => {
    useEffect(() => {
        // Capture a Sentry event when the error fallback renders,
        // covering cases where no exception was thrown.
        Sentry.captureMessage('Error fallback rendered', {
            level: 'error',
            extra: {
                path: window.location?.pathname,
                search: window.location?.search,
                hash: window.location?.hash,
                referrer: document.referrer || undefined,
            }
        });
    }, []);

    return (<div>
        <ErrorPage />
    </div>);
}